import { IPage2, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { getBaseCiRequestUrl, getToken } from '@/utils/constants'

//详情
export interface IMessagewarnlistDetail {
    /**
     * 所属业务编码
     */
    businessTypeCode?: null | string;
    /**
     * 所属业务名称
     */
    businessTypeName?: null | string;
    createTime?: number[];
    createUser?: null | string;
    /**
     * 完成人
     */
    endPerson?: null | string;
    /**
     * 完成时间
     */
    endTime?: null | string;
    id: string;
    /**
     * 已读人
     */
    readPerson?: null | string;
    /**
     * 已读时间
     */
    readTime?: null | string;
    /**
     * 接收人
     */
    recipient?: null | string;
    /**
     * 备注
     */
    remark?: null | string;
    /**
     * 状态
     */
    status?: null | string;
    /**
     * 主题
     */
    subject?: null | string;
    content?: null | string;
    traceId?: null | string;
    updateTime?: number[];
    updateUser?: null | string;
    /**
     * 预警分类编码
     */
    warningTypeCode?: null | string;
    /**
     * 预警分类名称
     */
    warningTypeName?: null | string;
    [property: string]: any;
}

//搜索条件
export interface IMessagewarnlistSearchFields {
    result?: string
    offset?: string
    module?: string
    ip?: string
    operationType?: string
    startTime?: string
    endTime?: string
    operator?: string
}

class MessagewarnlistService {
    async page(searchVo: any, config: object = {}) {
        const apiUrl = "/yh-franchisee/message/listPage";
        return await httpRequest.post<IPage2<IMessagewarnlistDetail>>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
    async read(id: string) {
        const apiUrl = `/yh-franchisee/message/read/${id}`;
        return await httpRequest.get<IPage2<IMessagewarnlistDetail>>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
    async end(data: { id: string, remark?: string }) {
        const apiUrl = `/yh-franchisee/message/end`;
        return await httpRequest.post<IPage2<IMessagewarnlistDetail>>(apiUrl, data, { baseURL: getBaseCiRequestUrl(), token: getToken() });
    }
}

export const messagewarnlistService = new MessagewarnlistService();
